export default __webpack_public_path__ + "static/sphereOrbitImage-f751dd30b3e1fd52022c2d720ca9cc9f.png";